import React from 'react';
import { bool, number, string } from 'prop-types';
import Field from 'redux-form/es/Field';
import { FormattedMessage } from 'react-intl';
import { fromCents } from 'utils/helpers';
import InputField from '../../../Core/Controls/InputField';
import QuestionText from '../reusable/QuestionText';
import RadioBoxesWithInput from '../reusable/RadioBoxesWithInput';
import { fieldNames } from '../const';

const OngoingTransferQuestion = (props) => {
  const {
    bankStatementOngoingTransfersMonthlyAmount,
    shouldShowExtraPartOfTransferQuestion,
    selectedValue,
    id,
  } = props;

  const formattedNumber = fromCents(bankStatementOngoingTransfersMonthlyAmount);
  const shouldShowTextInput = selectedValue === 'OTHER';
  const ongoingTransferOptions = [
    {
      title: 'followup.question.ongoingTransfer.no',
      value: 'NO',
    },
    {
      title: 'followup.question.ongoingTransfer.yes',
      value: 'YES',
    },
  ];

  const extraPartOngoingTransferOptions = [
    {
      title: 'followup.question.ongoingTransfer.extra.other-finance',
      value: 'OTHER_FINANCE',
    },
    {
      title: 'followup.question.ongoingTransfer.extra.living',
      value: 'ACCOMMODATION',
    },
    {
      title: 'followup.question.ongoingTransfer.extra.family',
      value: 'SUPPORTING_FAMILY',
    },
    {
      title: 'followup.question.ongoingTransfer.extra.other',
      value: 'OTHER',
    },
  ];

  return (
    <div className="followup__question-container">
      <QuestionText
        textId="followup.question.ongoingTransfer"
        values={{ bankStatementOngoingTransfersMonthlyAmount: formattedNumber }}
      />

      <RadioBoxesWithInput
        fieldName={`${fieldNames.ongoingTransfers}-${id}`}
        options={ongoingTransferOptions}
      />

      {
        shouldShowExtraPartOfTransferQuestion && (
          <React.Fragment>
            <QuestionText
              textId="followup.question.ongoingTransfer.extraPart"
            />

            <div className="followup__ongoing-transfer-container">
              <div className="followup__ongoing-transfer-container--input">
                <Field
                  name={`${fieldNames.ongoingTransferExtraPartAmount}-${id}`}
                  component={InputField}
                  prefix="$"
                  useDigitsGrouping
                  isErrorVisible
                  errorValues={{ min: 0, max: 10000 }}
                />
              </div>

              <div className="followup__ongoing-transfer-container--message">
                <FormattedMessage id="followup.question.ongoingTransfer.extraPart.perMont" />
              </div>
            </div>

            <RadioBoxesWithInput
              fieldName={`${fieldNames.ongoingTransfersExtraPart}-${id}`}
              options={extraPartOngoingTransferOptions}
              shouldShowTextInput={shouldShowTextInput}
              textInputName={`${fieldNames.ongoingTransfersExtraPartClarification}-${id}`}
              textInputTitleId="followup.question.ongoingTransfersExtraPart.clarification"
            />
          </React.Fragment>
        )
      }
    </div>

  );
};

OngoingTransferQuestion.propTypes = {
  bankStatementOngoingTransfersMonthlyAmount: number,
  shouldShowExtraPartOfTransferQuestion: bool,
  selectedValue: string,
  id: number,
};

export default OngoingTransferQuestion;
